import { Input, Popover } from 'antd';
import { toast } from "react-toastify";
import axios from 'axios';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';
import { BulkModeCTA1, Songplace } from '../../components';
import { BackupIcon, FixIcon, PlayListNew } from '../../assets';
import { SPOTIFY_TOKEN } from '../../constants/storage';
import { useLoginContext } from '../../context';
import { usePlaylistContext } from '../../context/PlaylistContext';
import { FilledButtonStyle } from '../../styles/common.style';
import {
  addItemToStorage,
  addSongToPlaylist,
  deleteAllRefresh,
  getRefreshedToken,
  refreshPlaylist,
} from '../../utils';
import { AddToPlayListModalStyle } from '../../components/AddToPlayListModal/AddToPlayListModal.style';
import PlanToast from '../../components/PlanToast/PlanToast';
import SyncModal from '../../components/PlayListBanner/SyncModal';
import RestoreModal from '../../components/PlayListBanner/RestoreModal';
import Spinner from '../../components/Spinner/Spinner';
import { BASE_URL } from '../../constants/api-urls';
import DeleteModal from '../../components/Subscriptions/CancelSubscription';
import ScheduleRefreshModal from '../../components/PlayListBanner/ScheduleRefreshModal';
import ScheduleFixModal from '../../components/PlayListBanner/ScheduleFixModal';
import { PlaylistNewBannerStyle } from './PlaylistNewBanner.style';

interface PlaylistNewBannerProps {
  title?: string;
  desc?: string;
  totalSongs?: string;
  image?: string;
  token?: string;
  songs?: any[];
  onScheduleRefreshSuccess?: (scheduleData: any) => void;
  onScheduleDeleteSuccess?: () => void;
  onScheduleResetScheduleSuccess?: (scheduleData: any) => void;
  onScheduleResetSuccess?: () => void;
  onScheduleResetDeleteSuccess?: () => void;
  currentPage?: number;
  setAddToPlaylistModal?: any;
  userId?: string;
  handleRefresh?: (
    values: any,
    deleteAllRefresh: any,
    refreshPlaylist: any,
    token: any,
    songs: any,
    handleRefresh: any
  ) => void;
  setIsModalVisible: (boolean) => void;
  isModalVisible?: boolean;
  currentPlaylistData?: any;
  hideFullPlaylistMode?: any;
  fixed?: any;
  refreshPlaylistFunction?: any;
  currentPlaylist?: any;
  isRefreshScheduled?;
  syncdatafromspotify?: any;
  restorePlaylsitSongs?: any;
  PlaylistRefreshRecord?: any;
  bulkAction?: any;
  setBulkAction?: any;
  showModalDeleteSelected?: any;
  selectedSongs?: any;
  refreshScheduleData?: any;
  getScheduleRefreshData?: any;
  getScheduleFixData?: any;
  fixScheduleFData?: any;
  hasFixSong?: any;
}

const PlaylistNewBanner = (props: PlaylistNewBannerProps) => {
  const { playlistId } = useParams();
  const { state } = usePlaylistContext();
  const { title, totalSongs, image, token, songs, userId, setAddToPlaylistModal, desc } = props;
  const { state: playlistState } = usePlaylistContext();
  const selectRefreshFreq = {
    value: 'Once(Manually)',
    frequency: 'spotifyPlaylistRefreshOperationOnce',
  };
  const { dispatch: newDispatch } = usePlaylistContext();
  const { state: loginState, dispatch: loginDispatch } = useLoginContext();
  const navigate = useNavigate();

  // Helper to check if current user can see a scheduler
  // If scheduler has no userId (legacy), show it
  // If scheduler has userId, only show if it matches current user or profile owner
  const canUserSeeScheduler = (schedulerData: any): boolean => {
    if (!schedulerData) return false;
    // Legacy scheduler without userId - show to everyone (backwards compatible)
    if (!schedulerData.userId) {
      return true;
    }
    
    // Scheduler has userId - check if it matches current user or profile owner
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    
    const currentUserId = userInfo?.userId;
    const profileOwnerId = spotifyUser.isShared === true ? spotifyUser.ownerId : null;
    
    // Match against current user's Auth0 ID or profile owner's Auth0 ID
    const canSee = schedulerData.userId === currentUserId || schedulerData.userId === profileOwnerId;
    return canSee;
  };

  // All state declarations organized at the top
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [datePickeropen, setdatePickeropen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [datePickeropenFix, setdatePickeropenFix] = useState(false);
  const [versionRestore, setVersionRestore] = useState(0);
  const [saveRestore, setSaveRestore] = useState(true);
  const [theme, setTheme] = useState('dark');
  const [name, setname] = useState(title);
  const [syncModal, setsyncModal] = useState(false);
  const [restoreModal, setrestoreModal] = useState(false);
  const [restoreNowModal, setrestoreNowModal] = useState(false);
  const [description, setdescription] = useState('');
  const [updatedDesc, setUpdatedDesc] = useState('');
  const [isModalVisible, setisModalVisible] = useState(false);
  const [isRestoreModalVisible, setisRestoreModalVisible] = useState(false);
  const [restoreModalLoader, setRestoreModalLoader] = useState(false);
  const [scheduleRefreshModal, setScheduleRefreshModal] = useState(false);
  const [scheduleFixModal, setScheduleFixModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [openDatePicker, setOpenDatePicker] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [openDatePickerFix, setOpenDatePickerFix] = useState(false);
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [isModalOpenFixDelete, setIsModalOpenFixDelete] = useState(false);
  const [isEditPlaylistModalVisible, setIsEditPlaylistModalVisible] = useState(false);
  const [scheduleType, setScheduleType] = useState('');
  const [scheduleFixType, setScheduleFixType] = useState('');
  const [scheduleDateTime, setScheduleDateTime] = useState(new Date());
  const [scheduleFixDateTime, setScheduleFixDateTime] = useState(new Date());
  const [scheduleLaoder, setScheduleLoader] = useState(false);
  const [scheduleLaoderFix, setScheduleLoaderFix] = useState(false);
  const [scheduleDateTimeDatePicker, setScheduleDateTimeDatePicker] = useState<any>();
  const [scheduleDateFixTimeDatePicker, setScheduleFixDateTimeDatePicker] = useState<any>();

  // Tilt effect state
  const [isTilted, setIsTilted] = useState(false);
  const [tiltStyle, setTiltStyle] = useState({ transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg)' });

  const handleLearnMoreBulkMode = () => {
    navigate('/user-guide#bulk-mode');
  };

  const showModalDelete = () => {
    setIsModalOpenDelete(true);
    handleScheduleModalCancel();
  };

  const handleOkDelete = () => {
    setIsModalOpenDelete(false);
    deletePlaylistRefresh();
  };

  const handleCancelDelete = () => {
    setIsModalOpenDelete(false);
    handleScheduleModalShow();
  };

  const showModalFixDelete = () => {
    setIsModalOpenFixDelete(true);
    handleScheduleFixModalCancel();
  };

  const handleOkFixDelete = () => {
    setIsModalOpenFixDelete(false);
    deletePlaylistFix();
  };

  const handleCancelFixDelete = () => {
    setIsModalOpenFixDelete(false);
    handleScheduleFixModalShow();
  };

  // Tilt effect handlers
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isTilted) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = (y - centerY) / 10;
    const rotateY = (centerX - x) / 10;

    setTiltStyle({
      transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.05)`
    });
  };

  const handleMouseEnter = () => {
    setIsTilted(true);
    setTiltStyle({
      transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1.05)'
    });
  };

  const handleMouseLeave = () => {
    setIsTilted(false);
    setTiltStyle({
      transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)'
    });
  };

  useEffect(() => {
    setname(title);
    setdescription(desc);
  }, [title, desc, playlistId, isEditPlaylistModalVisible]);

  useEffect(() => {
    setTheme(playlistState?.isWholeTheme === false ? 'dark' : 'light');
  }, [playlistState]);

  const handleCancel = () => {
    props.setIsModalVisible(false);
  };

  const handleOk = values => {
    addSongToPlaylist(
      Array.isArray(values.playlistId) ? values.playlistId : [values.playlistId],
      values.frequency,
      token,
      loginState.refreshToken,
      userId,
      0,
      '2023-08-08',
      '2023-08-08',
      null,
      ''
    );
    props.setIsModalVisible(false);
  };

  const handleScheduleModalShow = () => {
    setScheduleRefreshModal(true);
  };

  const handleScheduleModalCancel = () => {
    setScheduleRefreshModal(false);
  };
  const handleScheduleModalhandleOk = values => {
    setScheduleRefreshModal(false);
  };

  const handleScheduleFixModalShow = () => {
    setScheduleFixModal(true);
  };

  const handleScheduleFixModalCancel = () => {
    setScheduleFixModal(false);
  };
  const handleScheduleFixModalhandleOk = values => {
    setScheduleFixModal(false);
  };

  const array = [];
  playlistState?.playlists &&
    playlistState?.playlists.length > 0 &&
    playlistState?.playlists.forEach((e, index) => {
      const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser'));
      if (e?.owner?.display_name !== spotifyUser?.username && e?.id === playlistId) {
        array.push(e?.owner?.display_name);
      }
    });

  const playListGet = async (call?: any) => {
    axios(`https://api.spotify.com/v1/me/playlists?limit=8&offset=3`, {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + loginState.token },
    })
      .then(async genreResponse => {
        newDispatch({
          type: 'INITIALIZE_PLAYLISTS',
          payload: genreResponse?.data?.items,
        });
        if (call) {}
      })
      .catch(async error => {
        if (error.response?.data?.error?.status === 401 || error.response?.status === 400) {
          getRefreshedToken(state.refreshToken)
            .then(response => {
              addItemToStorage(SPOTIFY_TOKEN, response?.data?.access_token);

              loginDispatch({
                type: 'ADD_TOKEN',
                payload: response?.data?.access_token,
              });
            })
            .catch(() => {});
        }
      });
  };

  const handleEditPlaylistDetails = async values => {
    let obj =
      values?.playlistname && values.playlistDescription
        ? JSON.stringify({
            name: values?.playlistname,
            description: values.playlistDescription,
          })
        : values?.playlistname
        ? JSON.stringify({
            name: values?.playlistname,
          })
        : values?.playlistDescription
        ? JSON.stringify({
            description: values.playlistDescription,
          })
        : {};
    try {
      axios(`https://api.spotify.com/v1/playlists/${playlistId}`, {
        headers: {
          Authorization: 'Bearer ' + loginState.token,
        },
        data: obj,
        method: 'PUT',
      }).then(() => {
        setUpdatedDesc(values.playlistDescription);
        setIsEditPlaylistModalVisible(false);
        playListGet(true);
        window.location.reload();
      });
    } catch (error) {}
  };

  const ScheduleRefreshFn = () => {
    setScheduleLoader(true);

    // Get userId from localStorage for new scheduler creation
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');

    // Use profile owner's userId for shared profiles, own userId otherwise
    const schedulerUserId =
      spotifyUser.isShared === true ? spotifyUser.ownerId : userInfo?.userId;

    if (props.refreshScheduleData) {
      let obj = {
        nextrefreshtTime: props.refreshScheduleData.nextrefreshtTime,
        refreshTime: props.refreshScheduleData.refreshTime,
        type: scheduleType,
        accessToken: loginState.refreshToken,
        backup: saveRestore,
        errorInQueue: false,
      };
      if (scheduleDateTimeDatePicker) {
        // @ts-ignore
        obj.refreshValue = new Date(scheduleDateTimeDatePicker).getTime();
      }
      axios(`${BASE_URL}/updateRefreshlogs/${props.refreshScheduleData._id}`, {
        data: obj,
        method: 'put',
      }).then(res => {
        setScheduleLoader(false);
        handleScheduleModalCancel();
        // First update optimistically with response data
        props.onScheduleRefreshSuccess?.(res.data);
        // Then fetch fresh data from server to ensure consistency
        props.getScheduleRefreshData?.(playlistId);
        toast.success('Schedule refresh updated successfully');
      });
    } else {
      if (!schedulerUserId) {
        setScheduleLoader(false);
        toast.error('User not authenticated');
        return;
      }

      if (scheduleType) {
        let obj = {
          playlist_id: playlistId,
          accessToken: loginState.refreshToken,
          type: scheduleType,
          backup: saveRestore,
          refreshTime: scheduleDateTimeDatePicker,
          userId: schedulerUserId,
        };
        axios(`${BASE_URL}/addRefreshlogs`, {
          data: obj,
          method: 'post',
        })
          .then(res => {
            setScheduleLoader(false);
            handleScheduleModalCancel();
            // First update optimistically with response data
            props.onScheduleRefreshSuccess?.(res.data);
            // Then fetch fresh data from server to ensure consistency
            props.getScheduleRefreshData?.(playlistId);
            toast.success('Schedule refresh created successfully');
          })
          .catch(err => {
            setScheduleLoader(false);
            toast.error('Failed to create schedule refresh');
          });
      } else {
        setScheduleLoader(false);

        toast.error('Please Select Duration');
      }
    }
  };

  useEffect(() => {
    if (props.refreshScheduleData) {
      setScheduleType(props.refreshScheduleData?.type);
      setSaveRestore(props.refreshScheduleData.backup !== false);
      setScheduleDateTime(new Date(Number(props.refreshScheduleData.nextrefreshtTime)));
    }
  }, [props.refreshScheduleData]);

  const ScheduleFixFn = () => {
    setScheduleLoaderFix(true);

    // Get userId from localStorage for new scheduler creation
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');

    // Use profile owner's userId for shared profiles, own userId otherwise
    const schedulerUserId =
      spotifyUser.isShared === true ? spotifyUser.ownerId : userInfo?.userId;

    if (props.fixScheduleFData) {
      let obj = {
        nextFixPlaylistTime: props.fixScheduleFData.nextrefreshtTime,
        fixPlaylistTime: props.fixScheduleFData.refreshTime,
        type: scheduleFixType,
        accessToken: loginState.refreshToken,
        backup: saveRestore,
      };
      if (scheduleDateFixTimeDatePicker) {
        // @ts-ignore
        obj.refreshValue = new Date(scheduleDateFixTimeDatePicker).getTime();
      }
      axios(`${BASE_URL}/updatefixplaylistLogs/${props.fixScheduleFData._id}`, {
        data: obj,
        method: 'put',
      }).then(res => {
        setScheduleLoaderFix(false);
        handleScheduleFixModalCancel();
        // Update schedule data without clearing lock positions
        props.onScheduleResetScheduleSuccess?.(res.data);
        // Then fetch fresh data from server to ensure consistency
        props.getScheduleFixData?.(playlistId);
        toast.success('Schedule reset updated successfully');
      }).catch(err => {
        setScheduleLoaderFix(false);
        toast.error('Failed to update schedule reset');
      });
    } else {
      if (!schedulerUserId) {
        setScheduleLoaderFix(false);
        toast.error('User not authenticated');
        return;
      }

      if (scheduleFixType) {
        let obj = {
          playlist_id: playlistId,
          accessToken: loginState.refreshToken,
          type: scheduleFixType,
          backup: saveRestore,
          fixPlaylistTime: scheduleDateFixTimeDatePicker,
          userId: schedulerUserId,
        };
        axios(`${BASE_URL}/addfixplaylistlogs`, {
          data: obj,
          method: 'post',
        })
          .then(res => {
            setScheduleLoaderFix(false);
            handleScheduleFixModalCancel();
            // Update schedule data without clearing lock positions
            props.onScheduleResetScheduleSuccess?.(res.data);
            // Then fetch fresh data from server to ensure consistency
            props.getScheduleFixData?.(playlistId);
            toast.success('Schedule reset created successfully');
          })
          .catch(err => {
            setScheduleLoaderFix(false);
            toast.error('Failed to create schedule reset');
          });
      } else {
        setScheduleLoaderFix(false);
        toast.error('Please Select Duration');
      }
    }
  };

  useEffect(() => {
    if (props.fixScheduleFData) {
      setScheduleFixType(props.fixScheduleFData?.type);
      setSaveRestore(props.fixScheduleFData.backup !== false);
      setScheduleFixDateTime(new Date(Number(props.fixScheduleFData.nextrefreshtTime)));
    }
  }, [props.fixScheduleFData]);
  const deletePlaylistRefresh = () => {
    axios(`${BASE_URL}/deleteRefreshlogs/${playlistId}`, {
      method: 'delete',
    }).then(res => {
      // Update local state to clear refresh schedule data
      props.onScheduleDeleteSuccess?.();
      toast.success('Refresh schedule deleted successfully');
    }).catch(err => {
      toast.error('Failed to delete refresh schedule');
    });
  };
  const deletePlaylistFix = () => {
    axios(`${BASE_URL}/deletefixplaylistLogs/${playlistId}`, {
      method: 'delete',
    }).then(res => {
      // Update local state to clear reset schedule data
      props.onScheduleResetDeleteSuccess?.();
      toast.success('Reset schedule deleted successfully');
    }).catch(err => {
      toast.error('Failed to delete reset schedule');
    });
  };


  return (
    <>
      <PlaylistNewBannerStyle>
        <div className={`bannerDiv ${props.fixed ? 'hidebanner' : ''}`}>
          <div className="playlistActions">
            <div className="innerPlaylistActions">
              <div className="actionDiv" style={{ position: 'relative' }}>
                <PlanToast available={['free', 'pro', 'unlimited']} titleHeading={'ADD IN BULK'}>
                  <Popover
                    content={
                      <div>
                        <p>Enable bulk mode to add songs with the current date and time</p>
                        <p style={{ marginTop: '8px', marginBottom: '0' }}>
                          <button
                            onClick={handleLearnMoreBulkMode}
                            style={{
                              color: '#1890ff',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              fontSize: '14px',
                              border: 'none',
                              background: 'none',
                              padding: '0',
                              fontFamily: 'inherit'
                            }}
                          >
                            Learn more
                          </button>
                        </p>
                      </div>
                    }
                    placement="bottomLeft"
                  >
                    <p>
                      <span className="textAction">Add in bulk:</span> <BulkModeCTA1 />
                    </p>
                  </Popover>
                </PlanToast>
              </div>
              <div className="actionDiv">
                <PlanToast available={['pro', 'unlimited']} titleHeading={'Songplace only'}>
                  <Popover
                    content={
                      <div>
                        <p>
                          Enable Songplace only mode to view songs with their scheduled date and time
                        </p>
                        <p style={{ marginTop: '8px', marginBottom: '0' }}>
                          <button
                            onClick={e => {
                              e.preventDefault();
                              navigate('/user-guide#songplace-only-mode');
                            }}
                            style={{
                              color: '#1890ff',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                              fontSize: '14px',
                              border: 'none',
                              background: 'none',
                              padding: '0',
                              fontFamily: 'inherit'
                            }}
                          >
                            Learn more
                          </button>
                        </p>
                      </div>
                    }
                    placement="bottomLeft"
                  >
                    <p>
                      <span className="textAction">Songplace only:</span> <Songplace />
                    </p>
                  </Popover>
                </PlanToast>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="text-container">
              <div className="platform">
                <img alt="spotify" src={'./../static/Spotify_Logo_RGB_Green.png'} />{' '}
              </div>
              <div className="row1">
                <div style={{ display: 'flex', alignItems: 'center', width: '20px', height: '20px' }}>
                  {theme === 'dark' ? (
                    <PlayListNew color={'white'} />
                  ) : (
                    <PlayListNew color={'#1D1D1D'} />
                  )}
                </div>
                <p className="p1">Playlist</p>
              </div>
              <div className="row-space" style={{}}>
                <div style={{ width: '100%' }}>
                  <Popover content={<p>{title}</p>} placement="topLeft">
                    <h1 className="title">{title}</h1>
                  </Popover>
                  {(updatedDesc || desc) && (
                    <p className="desc">{updatedDesc ? updatedDesc : desc}</p>
                  )}
                </div>
              </div>
              <div className="p2">
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p>Spotify</p>
                    <span className="platForm">-</span>
                    <p className="platForm">
                      {totalSongs} & {props.currentPlaylistData?.followers?.total} followers{' '}
                    </p>
                  </div>
                  {props.refreshScheduleData && canUserSeeScheduler(props.refreshScheduleData) && (
                    <Popover
                      content={
                        <div style={{ textAlign: 'center' }}>
                          {props.refreshScheduleData?.paused ? (
                            <>
                              <p style={{ color: '#ff9800', marginBottom: '8px', fontWeight: '600', fontSize: '16px' }}>
                                ⏸️ Refresh Paused
                              </p>
                              <p style={{ marginBottom: '8px', lineHeight: '1.5', color: '#fff' }}>
                                Your scheduler is paused because you're no longer on the Unlimited plan.
                              </p>
                              <p style={{ marginBottom: '12px', lineHeight: '1.5', color: '#fff' }}>
                                Resume automatic scheduling by upgrading back to Unlimited.
                              </p>
                              <a 
                                href="/settings" 
                                style={{ 
                                  color: '#1890ff', 
                                  textDecoration: 'underline',
                                  fontSize: '14px',
                                  fontWeight: '500'
                                }}
                              >
                                Upgrade to Unlimited Plan
                              </a>
                            </>
                          ) : props.refreshScheduleData?.errorInQueue ? (
                            <>
                              <p style={{ color: '#b90808', marginBottom: '8px' }}>
                                Something went wrong while refreshing this playlist. Please reset to the default state and add a new refresh scheduler to avoid conflicts.
                              </p>
                              <button
                                style={{
                                  background: 'transparent',
                                  textDecoration: 'underline',
                                  color: '#b90808',
                                  border: 'none',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  padding: '0',
                                  fontFamily: 'inherit'
                                }}
                                onClick={() => {
                                  let data = JSON.parse(props.PlaylistRefreshRecord[0]?.uris);
                                  setrestoreNowModal(true);
                                  props.restorePlaylsitSongs(
                                    restoreModal,
                                    setrestoreModal,
                                    data[data.length - 1]?.version,
                                    (props?.refreshScheduleData && props?.refreshScheduleData?._id) ||
                                      false
                                  );
                                }}
                              >
                                Reset to default
                              </button>
                            </>
                          ) : (
                            <>
                              Next refresh:<br />
                              {moment(Number(props.refreshScheduleData.nextrefreshtTime)).format('DD/MM/YYYY hh:mm A')}{' '}
                              {Intl.DateTimeFormat().resolvedOptions().timeZone}
                            </>
                          )}
                        </div>
                      }
                      placement="top"
                    >
                      <div 
                        className="scheduledBadge" 
                        onClick={props.refreshScheduleData?.paused ? undefined : handleScheduleModalShow}
                        style={{
                          ...(props.refreshScheduleData?.errorInQueue
                            ? { background: '#b90808' }
                            : props.refreshScheduleData?.paused
                            ? { 
                                background: '#6b6b6b',
                                opacity: 0.7,
                                cursor: 'not-allowed'
                              }
                            : {}),
                        }}
                      >
                        <img
                          alt="Refresh"
                          src={'./static/refreshicon.svg'}
                          width="12"
                          height="12"
                        />
                        <span>{props.refreshScheduleData?.paused ? 'Paused' : 'Scheduled refresh'}</span>
                      </div>
                    </Popover>
                  )}
                  {props.fixScheduleFData && canUserSeeScheduler(props.fixScheduleFData) && (
                    <Popover
                      content={
                        <div style={{ textAlign: 'center' }}>
                          {props.fixScheduleFData?.paused ? (
                            <>
                              <p style={{ color: '#ff9800', marginBottom: '8px', fontWeight: '600', fontSize: '16px' }}>
                                ⏸️ Reset Paused
                              </p>
                              <p style={{ marginBottom: '8px', lineHeight: '1.5', color: '#fff' }}>
                                Your scheduler is paused because you're no longer on the Unlimited plan.
                              </p>
                              <p style={{ marginBottom: '12px', lineHeight: '1.5', color: '#fff' }}>
                                Resume automatic scheduling by upgrading back to Unlimited.
                              </p>
                              <a 
                                href="/settings" 
                                style={{ 
                                  color: '#1890ff', 
                                  textDecoration: 'underline',
                                  fontSize: '14px',
                                  fontWeight: '500'
                                }}
                              >
                                Upgrade to Unlimited Plan
                              </a>
                            </>
                          ) : props.fixScheduleFData?.errorInQueue ? (
                            <p style={{ color: '#b90808', margin: '0' }}>
                              Something went wrong while resetting the playlist. Please apply a new scheduler to avoid further conflicts.
                            </p>
                          ) : (
                            <>
                              Next reset:<br />
                              {moment(Number(props.fixScheduleFData.nextFixPlaylistTime)).format('DD/MM/YYYY hh:mm A')}{' '}
                              {Intl.DateTimeFormat().resolvedOptions().timeZone}
                            </>
                          )}
                        </div>
                      }
                      placement="top"
                    >
                      <div 
                        className="scheduledBadge scheduledBadgeReset" 
                        onClick={props.fixScheduleFData?.paused ? undefined : handleScheduleFixModalShow}
                        style={{
                          ...(props.fixScheduleFData?.errorInQueue
                            ? { background: '#b90808' }
                            : props.fixScheduleFData?.paused
                            ? { 
                                background: '#6b6b6b',
                                opacity: 0.7,
                                cursor: 'not-allowed'
                              }
                            : {}),
                        }}
                      >
                        <div style={{ width: '12px', height: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <FixIcon />
                        </div>
                        <span>{props.fixScheduleFData?.paused ? 'Paused' : 'Scheduled reset'}</span>
                      </div>
                    </Popover>
                  )}
                </div>
              </div>

              <div className="songPlayListButtons hide-responsive">
                <button
                  className="addSong"
                  onClick={() => {
                    setAddToPlaylistModal(true);
                  }}
                >
                  <PlanToast available={['free', 'pro', 'unlimited']} titleHeading={'Add song'}>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1955_58822)">
                        <path
                          d="M8.5801 6.46961H13.6001V8.52961H8.5801H8.2801V8.82961V13.8496H6.2201V8.82961V8.52961H5.9201H0.900098V6.46961H5.9201H6.2201V6.16961V1.14961H8.2801V6.16961V6.46961H8.5801Z"
                          fill="white"
                          stroke="#007AFF"
                          strokeWidth="0.6"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1955_58822">
                          <rect
                            width="14"
                            height="14"
                            fill="white"
                            transform="translate(0.25 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Add song
                  </PlanToast>
                </button>

                <div style={{ 
                  width: '1px', 
                  height: '24px', 
                  background: 'rgba(255, 255, 255, 0.1)', 
                  margin: '0 8px' 
                }} />
                
                <Popover content={<p>Edit playlist name or description</p>} placement="top">
                  <button
                    className="iconButton"
                    onClick={() => {
                      setIsEditPlaylistModalVisible(true);
                    }}
                  >
                    <img src={'./static/images/EditIcon.svg'} alt="Edit" />
                  </button>
                </Popover>

                <Popover content={<p>Copy playlist URL</p>} placement="top">
                  <button
                    className="iconButton"
                    onClick={() => {
                      let str = `https://open.spotify.com${window.location.pathname}`;
                      navigator.clipboard.writeText(str);
                      toast.success('Playlist URL copied');
                    }}
                  >
                    <img
                      alt="Copy"
                      src={'./static/images/copyIcon.svg'}
                      width="20px"
                      height="20px"
                    />
                  </button>
                </Popover>

                <div style={{ position: 'relative' }}>
                  <PlanToast 
                    available={['unlimited']} 
                    titleHeading={'Refresh Playlist'} 
                    showPopup={true}
                    popoverContent={<p>Update all scheduled tracks in your playlist to the current date and time</p>}
                    learnMoreLink="/user-guide#refresh-playlist"
                  >
                    <button
                      className="iconButton"
                      onClick={() => {
                        props.refreshPlaylistFunction();
                      }}
                    >
                      <img
                        alt="Refresh"
                        src={'./static/refreshicon.svg'}
                        width="20px"
                        height="20px"
                      />
                    </button>
                  </PlanToast>
                </div>

                <div style={{ position: 'relative' }}>
                  <PlanToast 
                    available={['unlimited']} 
                    titleHeading={'Reset Playlist'} 
                    showPopup={true}
                    popoverContent={<p>Sync your playlist with songs that have a priority position locked</p>}
                    learnMoreLink="/user-guide#priority-fixed-position"
                  >
                    <button
                      className="iconButton iconButtonSvg iconButtonSvgReset"
                      onClick={() => {
                        setisModalVisible(true);
                      }}
                    >
                      <FixIcon />
                    </button>
                  </PlanToast>
                </div>

                <div style={{ position: 'relative' }}>
                  <PlanToast available={['unlimited']} titleHeading={'Restore Backup'}>
                    <Popover content={<p>Check for backups</p>} placement="top">
                      {props.PlaylistRefreshRecord &&
                      props.PlaylistRefreshRecord.length &&
                      props.PlaylistRefreshRecord[0]?.uris &&
                      JSON.parse(props.PlaylistRefreshRecord[0].uris).length ? (
                        <button
                          className="iconButton iconButtonSvg"
                          onClick={() => {
                            setisRestoreModalVisible(true);
                          }}
                        >
                          <BackupIcon />
                        </button>
                      ) : null}
                    </Popover>
                  </PlanToast>
                </div>

                {/* Hidden schedule refresh button - keeping JS code */}
                <div style={{ position: 'relative', display: 'none' }}>
                  <PlanToast available={['unlimited']} titleHeading={'Refresh Playlist'}>
                    <Popover
                      content={
                        <p>
                          {props?.refreshScheduleData?.errorInQueue
                            ? 'Something went wrong while refreshing this playlist. Please reset to the default state and add a new refresh scheduler to avoid conflicts.'
                            : 'Schedule "refresh playlist" based on your preferred date and time'}
                          {props?.refreshScheduleData?.errorInQueue ? (
                            <button
                              style={{
                                background: 'transparent',
                                textDecoration: 'underline',
                                color: 'red',
                                marginLeft: '5px',
                                border: 'none',
                              }}
                              onClick={() => {
                                let data = JSON.parse(props.PlaylistRefreshRecord[0]?.uris);
                                setrestoreNowModal(true);
                                props.restorePlaylsitSongs(
                                  restoreModal,
                                  setrestoreModal,
                                  data[data.length - 1]?.version,
                                  (props?.refreshScheduleData && props?.refreshScheduleData?._id) ||
                                    false
                                );
                              }}
                            >
                              Reset to default
                            </button>
                          ) : (
                            ''
                          )}
                        </p>
                      }
                      placement="topLeft"
                    >
                      {props.currentPlaylist?.length > 0 ? (
                        <button
                          className="editPlaylist"
                          style={
                            props?.refreshScheduleData?.errorInQueue
                              ? {
                                  background: '#b90808',
                                }
                              : {}
                          }
                          onClick={() => {
                            handleScheduleModalShow();
                          }}
                        >
                          <svg
                            width="15"
                            height="16"
                            viewBox="0 0 15 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.8333 0.499023C11.2936 0.499023 11.6667 0.872123 11.6667 1.33236V2.16569H13.3333C14.2538 2.16569 15 2.91188 15 3.83236V13.8324C15 14.7529 14.2538 15.499 13.3333 15.499H1.66667C0.746192 15.499 0 14.7529 0 13.8324V3.83236C0 2.91188 0.746192 2.16569 1.66667 2.16569H3.33333V1.33236C3.33333 0.872123 3.70642 0.872123 4.16667 1.33236C4.62691 1.33236 5 0.872123 5 1.33236V2.16569H10V1.33236C10 0.872123 10.3731 0.499023 10.8333 0.499023ZM13.3333 3.83236H1.66667V13.8324H13.3333V3.8324ZM9.85342 5.81462C10.1788 5.48919 10.7065 5.48919 11.0319 5.81462C11.3574 6.14006 11.3574 6.66769 11.0319 6.99311L6.91308 11.112C6.58433 11.4407 6.05142 11.4407 5.72276 11.112L3.96088 9.35019C3.63544 9.02469 3.63544 8.49711 3.96088 8.17161C4.28632 7.84619 4.81396 7.84619 5.13939 8.17161L6.31792 9.35019L9.85342 5.81462Z"
                              fill="white"
                            />
                          </svg>
                          {restoreNowModal ? <Spinner color="black" /> : 'Schedule refresh'}
                        </button>
                      ) : null}
                    </Popover>
                  </PlanToast>
                </div>

                {/* Hidden schedule reset button - keeping JS code */}
                <div style={{ position: 'relative', display: 'none' }}>
                  <PlanToast available={['unlimited']} titleHeading={'Refresh Playlist'}>
                    <Popover
                      content={
                        <p>
                          {props?.fixScheduleFData?.errorInQueue
                            ? 'Something went wrong while resetting the playlist. Please apply a new scheduler to avoid further conflicts.'
                            : `Schedule "reset song position" based on a custom date
                          and time`}
                        </p>
                      }
                      placement="topLeft"
                    >
                      {props.currentPlaylist?.length > 0 && props?.hasFixSong ? (
                        <button
                          className="editPlaylist"
                          onClick={() => {
                            handleScheduleFixModalShow();
                          }}
                          style={
                            props?.fixScheduleFData?.errorInQueue
                              ? {
                                  background: '#b90808',
                                }
                              : {}
                          }
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.27261 5L8.17669 7.02824L10.385 7.26131L8.73545 8.74791L9.1962 10.9202L7.27261 9.81073L5.34902 10.9202L5.80976 8.74791L4.16017 7.26131L6.36852 7.02824L7.27261 5Z"
                              fill="white"
                            />
                            <path
                              d="M10.8333 0C11.2936 0 11.6667 0.3731 11.6667 0.833333V1.66667H13.3333C14.2538 1.66667 15 2.41286 15 3.33333V13.3333C15 14.2538 14.2538 15 13.3333 15H1.66667C0.746192 15 0 14.2538 0 13.3333V3.33333C0 2.41286 0.746192 1.66667 1.66667 1.66667H3.33333V0.833333C3.33333 0.3731 3.70642 0 4.16667 0C4.62691 0 5 0.3731 5 0.833333V1.66667H10V0.833333C10 0.3731 10.3731 0 10.8333 0ZM13.3333 3.33333H1.66667V13.3333H13.3333V3.33333Z"
                              fill="white"
                            />
                          </svg>
                          Schedule reset playlist
                        </button>
                      ) : null}
                    </Popover>
                  </PlanToast>
                </div>

                <AddToPlayListModalStyle
                  visible={props.isModalVisible}
                  onOk={handleOk}
                  footer={null}
                  onCancel={handleCancel}
                >
                  <div>
                    <h1 className="heading">Refresh playlist</h1>
                  </div>
                  <p className="refreshDescription" style={{ opacity: '0.5' }}>
                    Refreshing the playlist will change the start date and time of each song to the
                    current date and time. Are you sure you want to continue?
                  </p>
                  <p className="refreshDescription" style={{ opacity: '0.5' }}>
                    Note: To help prevent any data loss, we recommend creating a backup for this
                    playlist.
                  </p>

                  <div className="checkBoxSaveVersion">
                    <div className="note">
                      <div
                        className="checkVersion"
                        onClick={() => {
                          setSaveRestore(!saveRestore);
                        }}
                      >
                        {saveRestore ? (
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                          </svg>
                        ) : null}
                      </div>
                      <span style={{ marginLeft: '0px' }}>Create a backup for this playlist.</span>
                    </div>
                  </div>
                  <div className="footer refreshModalFooter">
                    <div className="yesNoButtons">
                      <FilledButtonStyle
                        background="transparent"
                        width="90px"
                        type="button"
                        onClick={handleCancel}
                        className="btn1"
                      >
                        Cancel
                      </FilledButtonStyle>
                      <FilledButtonStyle
                        type="button"
                        className="btn2"
                        style={{ width: '170px', marginRight: '10px' }}
                        onClick={() => {
                          handleCancel();
                          handleScheduleModalShow();
                        }}
                      >
                        Schedule for later
                      </FilledButtonStyle>

                      <FilledButtonStyle
                        disabled={!selectRefreshFreq}
                        type="submit"
                        className="btn2"
                        style={{ width: '170px' }}
                        onClick={() => {
                          props.handleRefresh(
                            selectRefreshFreq,
                            deleteAllRefresh,
                            refreshPlaylist,
                            token,
                            songs,
                            saveRestore
                          );
                        }}
                      >
                        Refresh now
                      </FilledButtonStyle>
                    </div>
                  </div>
                </AddToPlayListModalStyle>

                <ScheduleRefreshModal
                  scheduleRefreshModal={scheduleRefreshModal}
                  handleScheduleModalhandleOk={handleScheduleModalhandleOk}
                  handleScheduleModalCancel={handleScheduleModalCancel}
                  scheduleDateTime={scheduleDateTime}
                  setScheduleDateTime={setScheduleDateTime}
                  scheduleDateTimeDatePicker={scheduleDateTimeDatePicker}
                  setScheduleDateTimeDatePicker={setScheduleDateTimeDatePicker}
                  scheduleType={scheduleType}
                  setScheduleType={setScheduleType}
                  setOpenDatePicker={setOpenDatePicker}
                  setdatePickeropen={setdatePickeropen}
                  saveRestore={saveRestore}
                  setSaveRestore={setSaveRestore}
                  scheduleLaoder={scheduleLaoder}
                  showModalDelete={showModalDelete}
                  ScheduleRefreshFn={ScheduleRefreshFn}
                  props={props}
                />
                <ScheduleFixModal
                  scheduleRefreshModal={scheduleFixModal}
                  handleScheduleModalhandleOk={handleScheduleFixModalhandleOk}
                  handleScheduleModalCancel={handleScheduleFixModalCancel}
                  scheduleDateTime={scheduleFixDateTime}
                  setScheduleDateTime={setScheduleFixDateTime}
                  scheduleDateTimeDatePicker={scheduleDateFixTimeDatePicker}
                  setScheduleDateTimeDatePicker={setScheduleFixDateTimeDatePicker}
                  scheduleType={scheduleFixType}
                  setScheduleType={setScheduleFixType}
                  setOpenDatePicker={setOpenDatePickerFix}
                  setdatePickeropen={setdatePickeropenFix}
                  saveRestore={saveRestore}
                  setSaveRestore={setSaveRestore}
                  scheduleLaoder={scheduleLaoderFix}
                  showModalDelete={showModalFixDelete}
                  ScheduleRefreshFn={ScheduleFixFn}
                  props={props}
                />
              </div>
            </div>
            <div
              className="playListPic"
              style={{
                width: image ? '' : '250px',
                ...tiltStyle,
                transition: isTilted ? 'transform 0.1s ease-out' : 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseMove={handleMouseMove}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {image ? (
                <img
                  className="image imagecontainerdirection"
                  src={image}
                  alt="playlist thumbnail"
                  style={{
                    transition: isTilted ? 'transform 0.1s ease-out' : 'transform 0.3s ease'
                  }}
                />
              ) : (
                <svg
                  className="playlistIcon"
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 512 512"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M429.46 32.07c-23.6 6.53-205.55 58.81-250.54 71.43a4 4 0 00-2.92 3.83v247a2 2 0 01-1.33 1.89l-27.85 9.55c-19 7.44-66.82 16.68-66.82 59.19 0 35.54 24.63 51.54 45.86 54.28a52.06 52.06 0 007.81.8c7.37 0 36.38-7.08 53.3-18.08C208 448.25 208 448 208 412V202c0-.9.62-.84 1.48-1.07l188-51.92a2 2 0 012.53 2v155.54a2 2 0 01-1.36 1.89c-8.9 3-19.23 6.5-26.48 9.12C341.39 328.68 304 335.65 304 376c0 38.51 28.26 54.58 46.3 55.83a87.37 87.37 0 0021.33-1c9-1.38 24.09-5.9 38.14-14.86C432 401.79 432 401.51 432 360V34a2 2 0 00-2.54-1.93z"></path>
                </svg>
              )}
            </div>
          </div>
          <AddToPlayListModalStyle
            visible={isEditPlaylistModalVisible}
            onOk={handleOk}
            footer={null}
            onCancel={() => {
              setname('');
              setdescription('');
              setIsEditPlaylistModalVisible(false);
            }}
          >
            <div>
              <h1 className="heading">Edit playlist details</h1>
            </div>
            {isEditPlaylistModalVisible ? (
              <>
                <div className="formAddToPlaylist">
                  <div className="formPlaylist">
                    <div className="playlistPosition">
                      <label className="label">
                        <p>Playlist name</p>
                        <Input
                          value={name}
                          placeholder="Playlist name"
                          onChange={value => {
                            setname(value.target.value);
                          }}
                          maxLength={100}
                        />
                      </label>
                    </div>
                    <label className="label">
                      <p>Description</p>
                      <Input.TextArea
                        className="addNoteText"
                        maxLength={300}
                        value={description}
                        placeholder="Description"
                        rows={4}
                        onChange={(value: any) => {
                          setdescription(value.target.value);
                        }}
                      />
                    </label>
                    <p className="textarea_count">{description.length} / 300</p>
                  </div>
                </div>
                <div className="buttonDiv">
                  <button
                    className="addSong"
                    onClick={() =>
                      handleEditPlaylistDetails({
                        playlistId: playlistId,
                        playlistname: name,
                        playlistDescription: description,
                      })
                    }
                  >
                    Done
                  </button>
                </div>
              </>
            ) : (
              ''
            )}
          </AddToPlayListModalStyle>
        </div>

        <AddToPlayListModalStyle
          visible={isModalVisible}
          footer={null}
          onCancel={() => {
            setisModalVisible(false);
          }}
          className="syncModal"
        >
          <div>
            <h1 className="heading">Reset position</h1>
          </div>
          <p className="refreshDescription">
            Resetting the positions will bring songs back to their originally reset positions. Are
            you sure you want to continue?
          </p>
          <div className="footer refreshModalFooter">
            <FilledButtonStyle
              background="transparent"
              width="90px"
              type="button"
              onClick={() => {
                setisModalVisible(false);
              }}
              className="btn1"
            >
              Cancel
            </FilledButtonStyle>
            <FilledButtonStyle
              type="button"
              className="btn2"
              style={{ width: '170px', marginRight: '10px' }}
              onClick={() => {
                setisModalVisible(false);
                handleScheduleFixModalShow();
              }}
            >
              Schedule for later
            </FilledButtonStyle>
            <FilledButtonStyle
              disabled={!selectRefreshFreq}
              type="submit"
              className="btn2"
              style={{ width: '170px' }}
              onClick={() => {
                setisModalVisible(false);
                setsyncModal(true);
                props.syncdatafromspotify({
                  syncModal,
                  setSyncModal: setsyncModal,
                });
              }}
            >
              Confirm
            </FilledButtonStyle>
          </div>
        </AddToPlayListModalStyle>

        <AddToPlayListModalStyle
          visible={isRestoreModalVisible}
          footer={null}
          onCancel={() => {
            setisRestoreModalVisible(false);
          }}
          className="syncModal"
        >
          <div>
            <h1 className="heading">Restore songs</h1>
          </div>
          <p className="refreshDescription">
            You can restore one or more backups by choosing the versions below:
          </p>
          <div className="verisonsUi">
            <div className="innerVerisonsUi">
              <p>Available backups:</p>
              {props.PlaylistRefreshRecord &&
                props.PlaylistRefreshRecord.length &&
                props.PlaylistRefreshRecord[0]?.uris &&
                JSON.parse(props.PlaylistRefreshRecord[0]?.uris).map((a, i) => (
                  <div
                    className="verisons"
                    onClick={() => {
                      setVersionRestore(a?.version);
                    }}
                  >
                    <div className="checkVersion">
                      {versionRestore === a?.version ? (
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 448 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
                        </svg>
                      ) : null}
                    </div>
                    Backup {a.date ? new Date(a.date).toDateString() : i + 1}
                    <span className="songsLength">({a?.uris?.length} Songs)</span>
                  </div>
                ))}
            </div>
          </div>
          <div className="footer">
            <FilledButtonStyle
              background="transparent"
              width="90px"
              type="button"
              onClick={() => {
                setisRestoreModalVisible(false);
              }}
              className="btn1"
            >
              Cancel
            </FilledButtonStyle>
            <FilledButtonStyle
              disabled={!versionRestore || restoreModalLoader}
              type="submit"
              className="btn2 restoreButton"
              style={{ width: '230px' }}
              onClick={() => {
                setRestoreModalLoader(true);
                props.restorePlaylsitSongs(
                  restoreModal,
                  setrestoreModal,
                  versionRestore,
                  props.refreshScheduleData?._id
                );
              }}
            >
              {restoreModalLoader ? <Spinner /> : 'Restore'}
            </FilledButtonStyle>
          </div>
        </AddToPlayListModalStyle>

        <SyncModal isModalVisible={syncModal} setIsModalVisible={setsyncModal} />
        <RestoreModal isModalVisible={restoreModal} setIsModalVisible={setrestoreModal} />
      </PlaylistNewBannerStyle>
      <DeleteModal
        handleCancel={handleCancelDelete}
        showModal={showModalDelete}
        isModalOpen={isModalOpenDelete}
        handleOk={handleOkDelete}
        heading={'Remove schedule'}
        headingText={'Are you sure you want to remove this schedule?'}
        positionWarning={''}
        button1={'Yes, remove'}
        button2={'Cancel'}
      />
      <DeleteModal
        handleCancel={handleCancelFixDelete}
        showModal={showModalFixDelete}
        isModalOpen={isModalOpenFixDelete}
        handleOk={handleOkFixDelete}
        heading={'Remove schedule'}
        headingText={'Are you sure you want to remove this schedule?'}
        positionWarning={''}
        button1={'Yes, remove'}
        button2={'Cancel'}
      />
    </>
  );
};

export default PlaylistNewBanner;
